import { useQuery } from '@tanstack/react-query';
import {
  defaultQuotationsListSort,
  emptyQuotationsListFilters,
  quotationsListPicAssigneeKey,
  quotationsListPicAssigneeReady,
  strapiListQuotations,
  type QuotationsListFilters,
  type QuotationsListPicAssignee,
  type QuotationsListSort,
  type QuotationsListVisibility,
} from '../../api/strapiCrm';
import { queryKeys } from '../queryKeys';

/** Ringkasan / dropdown: halaman pertama, hingga 200 baris (total meta tetap akurat). */
export function useQuotationsQuery(
  jwt: string | null,
  filters: QuotationsListFilters = emptyQuotationsListFilters,
) {
  return useQuery({
    queryKey: queryKeys.quotations(jwt, filters),
    queryFn: () =>
      strapiListQuotations(jwt!, {
        filters,
        sort: defaultQuotationsListSort,
        page: 1,
        pageSize: 200,
      }),
    enabled: Boolean(jwt),
    refetchOnWindowFocus: false,
  });
}

/** Daftar quotation dengan pagination server (selaras total Strapi vs DataGrid). */
export function useQuotationsListQuery(
  jwt: string | null,
  filters: QuotationsListFilters,
  sort: QuotationsListSort,
  page: number,
  pageSize: number,
  options?: { visibility?: QuotationsListVisibility; picAssignee?: QuotationsListPicAssignee },
) {
  const picAssignee = options?.picAssignee;
  const picReady =
    options?.visibility !== 'marketing_pic' || quotationsListPicAssigneeReady(picAssignee);
  return useQuery({
    queryKey: queryKeys.quotationsPage(
      jwt,
      filters,
      sort,
      page,
      pageSize,
      options?.visibility,
      quotationsListPicAssigneeKey(picAssignee),
    ),
    queryFn: () =>
      strapiListQuotations(jwt!, {
        filters,
        sort,
        page,
        pageSize,
        visibility: options?.visibility,
        picAssignee,
      }),
    enabled: Boolean(jwt) && picReady,
    refetchOnWindowFocus: false,
  });
}
